import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    Paper,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSSelectField from "../../Components/Select/WSSelect";

export const CheckInDriver: React.FC<any> = React.memo((props) => {
    const { register, control } = useForm();
    const navigate = useNavigate();

    const [selectedIcon, setSelectedIcon] = useState<string>("delivery"); // State to track which icon is selected

    const handleIconClick = (icon: string) => {
        setSelectedIcon(icon); // Update the state with the clicked icon
    };

    const handleClick = (path: string) => {
        navigate(path);
    };

    // Define the columns for the grid
    const columns: IColumns[] = [
        {
            header: selectedIcon === "advanceOrder" ? "Advance Order#" : "Receipt#",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: selectedIcon === "advanceOrder" ? "Date" : "",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: "Driver",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Guest name",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Time",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Zone",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Driver went by",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Total Ord.Time",
            fieldName: "address",
            tooltip: true,
        },
    ];

    return (
        <Grid display="flex" flexDirection="column" minHeight="100vh">
            <Grid container direction="column" spacing={2} p={2} flex="1">
                {/* Header Section */}
                <Grid item>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
                                Driver Routing
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Grid display="flex" alignItems="center">
                                {/* Conditionally render the DateField for Advance Order */}
                                {selectedIcon === "advanceOrder" && (
                                    <WSDateField
                                        id="orderdate"
                                        name="orderdate"
                                        label=""
                                        dateFormat="D/MM/YYYY"
                                        control={control}
                                        defaultValue={null}
                                        rules={{ required: false }}
                                    />
                                )}
                                <Tooltip title="Delivery">
                                    <IconButton
                                        sx={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            marginRight: "8px",
                                            borderRadius: "2px",
                                            marginLeft: "16px",
                                            backgroundColor: selectedIcon === "delivery" ? "green" : "transparent", // Change background color based on selection
                                            color: selectedIcon === "delivery" ? "white" : "inherit", // Change text color based on selection
                                        }}
                                        onClick={() => handleIconClick("delivery")}
                                    >
                                        <WSIcons.DeliveryDiningIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Advance Order">
                                    <IconButton
                                        sx={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            marginRight: "8px",
                                            borderRadius: "2px",
                                            backgroundColor: selectedIcon === "advanceOrder" ? "green" : "transparent", // Change background color based on selection
                                            color: selectedIcon === "advanceOrder" ? "white" : "inherit", // Change text color based on selection
                                        }}
                                        onClick={() => handleIconClick("advanceOrder")}
                                    >
                                        <WSIcons.ReceiptLongIcon />
                                    </IconButton>
                                </Tooltip>
                                <IconButton onClick={() => handleClick("/")}>
                                    <WSIcons.CloseIcon sx={{ backgroundColor: "red", color: "white" }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Content Section */}
                <Grid container spacing={2} p={2}>
                    <Grid item xs={12} sm={10}>
                        <WSDataGrid id="itemGrid" title="" columns={columns} />
                    </Grid>

                    <Grid container item xs={12} sm={2} spacing={2}>
                        {/* Right sidebar details */}
                        <Grid item xs={12}>
                            <Paper
                                sx={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "16px",
                                    width: "200px",
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                    Selected
                                </Typography>
                                <Divider sx={{ margin: "8px 0" }} />
                                <Typography variant="body1" sx={{ textAlign: "center" }}>
                                    0
                                </Typography>
                                <Divider sx={{ margin: "8px 0" }} />
                                <Typography variant="body1" sx={{ textAlign: "right" }}>
                                    0.00
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper
                                sx={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "16px",
                                    width: "200px",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", textAlign: "center" }}
                                >
                                    Assigned
                                </Typography>
                                <Divider sx={{ margin: "8px 0" }} />
                                <Typography variant="body1" sx={{ textAlign: "center" }}>
                                    -
                                </Typography>
                                <Divider sx={{ margin: "8px 0" }} />
                                <Typography variant="body1" sx={{ textAlign: "right" }}>
                                    --
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper
                                sx={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "16px",
                                    width: "200px",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", textAlign: "center" }}
                                >
                                    Today's
                                </Typography>
                                <Divider sx={{ margin: "8px 0" }} />
                                <Typography variant="body1" sx={{ textAlign: "center" }}>
                                    -
                                </Typography>
                                <Divider sx={{ margin: "8px 0" }} />
                                <Typography variant="body1" sx={{ textAlign: "right" }}>
                                    --
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <WSSelectField
                                rules={{ required: true }}
                                {...register("selectdriver")}
                                id="selectdriver"
                                control={control}
                                defaultValue={"0"}
                                label="Select Driver"
                                name="selectdriver"
                                labelType="Normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" color="success" sx={{ width: "100%" }}>
                                IN
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" color="success" sx={{ width: "100%" }}>
                                Change Driver
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {/* Footer Section */}
            <Grid
                item
                sx={{
                    backgroundColor: "#333",
                    padding: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Grid sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                    <WSIcons.GTranslateIcon sx={{ color: "white" }} />
                </Grid>
                <Grid sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                    <Button
                        variant="outlined"
                        sx={{
                            color: "white",
                            borderColor: "green",
                            "&:hover": {
                                backgroundColor: "#2e7d32",
                            },
                        }}
                    >
                        Scan BarCode
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            color: "white",
                            borderColor: "green",
                            "&:hover": {
                                backgroundColor: "#2e7d32",
                            },
                        }}
                    >
                        Show Map
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
});
